import React, { useEffect, useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import useFormValidator from 'useFormValidator';
import { connect } from 'react-redux';
import Select from 'react-select';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import moment from 'moment';
import * as actions from '../action';
import * as c from '../constant';

function CreateAppointmentModal({
  createAppointments,
  getAppointmentsList,
  showAppointment,
  creating,
  statusOption,
}) {
  const [formData, setFormData] = useState({
    system_module_id: '',
    system_module_name: '',
    quota: '',
    period: '',
    appointment_date: '',
  });
  const validateForm = useFormValidator(formData, {
    system_module_id: 'required|object',
    quota: 'required|number',
    period: 'required',
    appointment_date: 'required',
  });
  const setModal = useContext(ModalContext);

  const periodOption = [
    { label: '6:30AM - 8:30AM', value: '6:30AM - 8:30AM' },
    { label: '9:30AM - 11:30AM', value: '9:30AM - 11:30AM' },
    { label: '1:00PM - 2:00PM', value: '1PM - 2PM' },
  ];
  const periodOptionOP = [
    { label: '7AM - 9AM', value: '7AM - 9AM' },
    { label: '10AM - 12NN', value: '10AM - 12NN' },
    { label: '1PM - 2PM', value: '1PM - 2PM' },
  ];

  const handleOnChangeDate =
    (key) =>
    ({ target: { value } }) => {
      setFormData({
        ...formData,
        [key]: value,
      });
    };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
      ...(key === 'system_module_id' && { system_module_name: e.name }),
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    if (!validateForm.response.is_passed) {
      return false;
    }

    const args = {
      ...formData,
      appointment_date: moment(formData.appointment_date).format('YYYY-MM-DD'),
    };

    return createAppointments(args, ({ data }) => {
      setModal({ isOpen: false });
      getAppointmentsList({
        system_module_id: _.get(data, 'attributes.system_module_id'),
      });
      showAppointment(data.id);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Transaction {validateForm.renderMessage('system_module_id')}
            </label>
            <Select
              placeholder="Select Module"
              onChange={handleOnChangeSelect('system_module_id')}
              options={statusOption}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Quota: {validateForm.renderMessage('quota')}
            </label>
            <input
              className="form-control"
              type="number"
              max="500"
              min="1"
              name="quota"
              onChange={onChange}
              value={_.get(formData, 'quota')}
            />
          </div>
          <div className="col-12 form-group">
            <label
              htmlFor="period"
              className="form-control-plaintext text-muted"
            >
              Period: {validateForm.renderMessage('period')}
            </label>
            <Select
              placeholder="Select Period"
              onChange={handleOnChangeSelect('period')}
              options={
                [5, 38, 39, 24].indexOf(+_.get(formData, 'system_module_id')) >
                  -1 &&
                ['HC', 'OHP', 'OP'].indexOf(
                  +_.get(formData, 'system_module_name')
                )
                  ? periodOptionOP
                  : periodOption
              }
            />
          </div>

          <div className="form-input-group col-12 col-md-12">
            <label
              htmlFor="last_name"
              className="form-control-plaintext text-muted"
            >
              Date: {validateForm.renderMessage('appointment_date')}
            </label>
            <DateInputPicker
              className="full-input"
              onChange={handleOnChangeDate('appointment_date')}
              value={_.get(formData, 'appointment_date') || ''}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={creating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateAppointmentModal.propTypes = {
  getAppointmentsList: PropTypes.instanceOf(Function).isRequired,
  createAppointments: PropTypes.instanceOf(Function).isRequired,
  showAppointment: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
  statusOption: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  roleList: _.get(api, `${c.GET_ROLE_LIST}.list`) || [],
  creating: api.loading.indexOf(c.CREATE_APPOINTMENTS) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateAppointmentModal);
